import { Box, TextField, styled } from '@mui/material';

export const VerificationCodeInputContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(2.1)
}));

export const VerificationInput = styled(TextField)(({ theme }) => ({
  maxWidth: theme.typography.pxToRem(40),
  input: {
    textAlign: 'center',
    fontWeight: 'bold',
    padding: 0,
    marginTop: theme.typography.pxToRem(18),
    marginBottom: theme.typography.pxToRem(14)
  },
  'input::-webkit-outer-spin-button, input::-webkit-inner-spin-button': {
    appearance: 'none'
  }
}));

export const CodeDashContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(2)
}));

export const DashDivider = styled(Box)(({ theme }) => ({
  width: theme.spacing(2.1),
  height: theme.typography.pxToRem(1),
  backgroundColor: theme.palette.secondary.main
}));
